<template>
  <transition name="slide">
    <div class="fixed-top m-2 message" v-show="show">
      <div class="alert alert-dismissible fade show" :class="[alert == true ? 'alert-danger' : 'alert-success']" role="alert">
        <p class="m-0" v-html="message"></p>
        <button type="button" class="close" data-dismiss="alert" aria-label="閉じる">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "FlushMessage",
  props: {
    message: String,
    alert: Boolean
  },
  data() {
    return {
      show: false
    }
  },
  mounted () {
    console.log(this.alert)
    this.show = ( this.message.length > 0 ) ? true : false
    const _this = this
    setTimeout(function(){
        _this.show = false;
    }, 5000);
  }
}
</script>

<style scoped>
.message {
  z-index: 1000;
}
.slide-enter-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: ease-in;
   -webkit-transition-timing-function: ease-in;
   -o-transition-timing-function: ease-in;
   transition-timing-function: ease-in;
}

.slide-leave-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
   max-height: 60px;
   overflow: hidden;
}

.slide-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}
</style>